import { InvalidCredentialsError, UnexpectedError } from "../../domain/errors";
import { ReferencesModel } from "../../domain/models/references-model";
import { ReferencesService } from "../../domain/usecases/references-service";
import { HttpPostClient, HttpStatusCode } from "../../protocols/http";
import { referencesMapper } from "./mappers/references-mapper";

export class RemoteReferencesService implements ReferencesService {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpPostClient<any, any>
  ) {}

  async loadRegions(params: any): Promise<ReferencesModel> {
    const httpResponse = await this.httpClient.post({
      url: this.url + "/reginerrors/getReginsGraph",
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

    async loadRegionMap(params: any): Promise<ReferencesModel> {
    const httpResponse = await this.httpClient.post({
      url: this.url + "/reginerrors/getReginsStats",
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
